"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockInvitationEmailLogoUrl = exports.invitationSummaryMock = exports.licenseMock = exports.draftUsersMock = exports.pendingUsersMock = void 0;
/* eslint-disable import/prefer-default-export */
exports.pendingUsersMock = {
    success: true,
    pendingInvitations: [
        {
            id: 217256,
            uuid: 'c57a41ef-c260-4cbe-a8aa-c2b37d5a5aaa',
            email: 'new_sso_user_5@example.com',
            role: 'user',
            tenant: 'test',
            nickname: 'User23312117',
            fullName: 'Firstname Lastname',
            dateInvited: null,
            teams: ['theAteam', 'theBTeam', 'avengers'],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
            course: ['Ruby on Rails'],
        },
        {
            id: 217255,
            uuid: 'c57a41ef-c260-4cbe-a8aa-c2b37d5a5aaa',
            email: 'new_sso_user_5@example.com',
            role: 'user',
            tenant: 'test',
            nickname: 'User23312117',
            fullName: 'Firstname Lastname',
            dateInvited: '2023-12-28T09:26:31.000Z',
            teams: ['theAteam', 'theBTeam', 'avengers'],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
            course: ['Ruby on Rails'],
        },
        {
            id: 217254,
            uuid: '331837e1-f3bf-4049-a89f-fb876fb87a91',
            email: 'new_sso_user_4@example.com',
            role: 'manager',
            tenant: 'test',
            nickname: 'User16923821',
            fullName: '',
            dateInvited: '2023-12-28T09:26:31.000Z',
            teams: ['theAteam', 'theBTeam', 'avengers'],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
            course: ['Ruby on Rails'],
        },
        {
            id: 217253,
            uuid: 'bd6465da-d032-40e2-b792-47e06ddc8e13',
            email: 'new_sso_user_3@example.com',
            role: 'user',
            tenant: 'test',
            nickname: 'User99171752',
            fullName: '',
            dateInvited: '2023-12-28T09:26:31.000Z',
            teams: ['avengers'],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
            course: ['.NET'],
        },
        {
            id: 217252,
            uuid: '69d35052-047d-4478-b8ee-105e2dd202f4',
            email: 'new_sso_admin_1@example.com',
            role: 'admin',
            tenant: 'test',
            nickname: 'User33633130',
            fullName: '',
            dateInvited: '2023-12-28T09:26:31.000Z',
            teams: [null],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
        },
        {
            id: 208819,
            uuid: 'c41b3001-218e-4b2d-aad0-217b9c2cc1bc',
            email: 'test+1@test.com',
            role: 'user',
            tenant: 'test',
            nickname: 'User20321014',
            fullName: null,
            dateInvited: '2023-11-14T19:34:09.000Z',
            teams: [null],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
        },
        {
            id: 208790,
            uuid: '3bdff949-6cfa-4306-8d13-b606d589c30d',
            email: 'textcx@mailinator.com',
            role: 'user',
            tenant: 'test',
            nickname: 'User69619125',
            fullName: null,
            dateInvited: '2023-11-14T17:12:56.000Z',
            teams: [null],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
            course: ['Java'],
        },
        {
            id: 193670,
            uuid: '2e9086ec-db79-4574-9dce-724b096c47b5',
            email: 'example@example.com',
            role: 'manager',
            tenant: 'test',
            nickname: 'User12524361',
            fullName: null,
            dateInvited: '2023-09-08T09:00:50.000Z',
            teams: ['SAST_old'],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
        },
        {
            id: 186324,
            uuid: '7fbc3eb8-a24f-4333-8bce-0e3e3312116e',
            email: 'mark.feferman.cx@gmail.com',
            role: 'user',
            tenant: 'test',
            nickname: 'User18525159',
            fullName: null,
            dateInvited: '2023-07-27T15:47:43.000Z',
            teams: [null],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
            course: ['Java'],
        },
        {
            id: 173292,
            uuid: '835deb7b-fd86-4cd3-8012-199abab5e89e',
            email: 'existing.manager@gmail.com',
            role: 'manager',
            tenant: 'test',
            nickname: 'User44139119',
            fullName: null,
            dateInvited: '2023-06-07T12:12:47.000Z',
            teams: [null],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
        },
        {
            id: 78093,
            uuid: 'b6cc02ed-9f13-4a0d-8b9b-61e7771ee09a',
            email: 'kollol@example.com',
            role: 'user',
            tenant: 'test',
            nickname: 'User91139239',
            fullName: null,
            dateInvited: '2022-05-06T16:28:49.000Z',
            teams: [null],
            invitedBy: {
                email: 'test@test.com',
                fullName: null,
                uuid: '009b2c62-391e-4ed4-a142-55d9e1c6fd23',
                profilePictureUrl: null,
            },
        },
    ],
    total: 75,
    dateInvited: {
        totalExpired: 74,
        totalAboutToExpire: 0,
        totalActive: 0,
    },
};
/* eslint-disable import/prefer-default-export */
exports.draftUsersMock = {
    success: true,
    draftUsers: [
        {
            uuid: 'a551f293-f1d5-438c-b369-faffa790e936',
            email: 'user_504@mailiantor.com',
            role: 'user',
            name: 'mDOTYZxJ',
            primaryCourseName: 'AngularJS',
            primaryCourseUuid: '8a180a03-5c66-459c-aae1-602163656b6d',
            teams: [],
            errors: ['domainNotAllowed'],
        },
        {
            uuid: '4c8cef60-663a-4828-8ea0-293f4b9aface',
            email: 'user_vvhhx@example.com',
            role: 'user',
            name: 'gzrRMUcf',
            primaryCourseName: '.NET - API Security',
            primaryCourseUuid: '42382720-e474-4765-afdc-536d8d586389',
            teams: [],
            errors: ['domainNotAllowed'],
        },
        {
            uuid: '2e04c2ac-1d37-4594-b3a7-b2be493f2aff',
            email: 'user_912187@mailiantor.com',
            role: 'manager',
            name: 'Alice Jones',
            primaryCourseName: 'Node.JS',
            primaryCourseUuid: 'fe03cb95-7b0b-4f0a-97a3-690114b836ff',
            teams: [
                {
                    name: 'niry',
                    isManager: true,
                },
            ],
            errors: ['domainNotAllowed'],
        },
        {
            uuid: 'eb0b65f7-00b7-4eaa-8bc9-0b62fb47cf78',
            email: 'user_121238@mailiantor.com',
            role: 'admin',
            name: 'Bob Brown',
            primaryCourseName: 'CISO test 2',
            primaryCourseUuid: '6ad1b7cb-9392-468f-9184-bc5fe00bc4c7',
            teams: [
                {
                    name: 'niry',
                    isManager: true,
                },
                {
                    name: 'team1',
                    isManager: false,
                },
                {
                    name: 'test1',
                    isManager: false,
                },
                {
                    name: 'test2',
                    isManager: false,
                },
            ],
            errors: ['domainNotAllowed'],
        },
        {
            uuid: '67b2c444-1a73-4d03-83fa-609a9df5b217',
            email: 'user_52127@mailiantor.com',
            role: 'manager',
            name: 'Alice Williams',
            primaryCourseName: 'Android',
            primaryCourseUuid: '14214b4b-15b2-444a-b077-d41b824652cd',
            teams: [
                {
                    name: 'niry',
                    isManager: true,
                },
            ],
            errors: ['domainNotAllowed'],
        },
        {
            uuid: '7f2e950f-a496-4bb0-ab7f-bd2417bc6c26',
            email: 'user_603mailiantor.com',
            role: 'manager',
            name: 'Bob Williams',
            primaryCourseName: 'Node.JS',
            primaryCourseUuid: 'fe03cb95-7b0b-4f0a-97a3-690114b836ff',
            teams: [
                {
                    name: 'team1',
                    isManager: true,
                },
            ],
            errors: ['domainNotAllowed', 'invalidEmailFormat'],
        },
        {
            uuid: '3cd01bff-16a4-4639-a2dc-76e9ac5e1119',
            email: 'user_407mailiantor.com',
            role: 'user',
            name: 'Bob Jones',
            primaryCourseName: '.NET',
            primaryCourseUuid: '760fc927-9b0d-4832-ac40-35789f9c2f25',
            teams: [
                {
                    name: 'teamX',
                    isManager: false,
                },
            ],
            errors: ['domainNotAllowed', 'invalidEmailFormat'],
        },
        {
            uuid: '0cb1f12f-b5d6-42d9-9a80-3ac8c6d562b8',
            email: 'user_229@mailiantor.com',
            role: 'manager',
            name: 'John Johnson',
            primaryCourseName: 'Android',
            primaryCourseUuid: '14214b4b-15b2-444a-b077-d41b824652cd',
            teams: [
                {
                    name: 'nir',
                    isManager: true,
                },
            ],
            errors: ['domainNotAllowed'],
        },
        {
            uuid: '790850bf-f276-45b0-a8be-af721ed60537',
            email: 'user_4a53@mailiantor.com',
            role: 'user',
            name: 'John Williams',
            primaryCourseName: '.NET Advanced 2',
            primaryCourseUuid: '69668c4b-3ddb-4c33-803a-7a9f3f476cb2',
            teams: [
                {
                    name: 'nixr',
                    isManager: false,
                },
            ],
            errors: ['domainNotAllowed'],
        },
        {
            uuid: 'cebf35a9-7979-4001-a923-2942947bee1a',
            email: 'user_87d8@mailiantor.com',
            role: 'manager',
            name: 'John Johnson',
            primaryCourseName: 'Node.JS',
            primaryCourseUuid: 'fe03cb95-7b0b-4f0a-97a3-690114b836ff',
            teams: [
                {
                    name: 'niry',
                    isManager: true,
                },
            ],
            errors: ['domainNotAllowed'],
        },
    ],
    total: 18,
    totalErrors: {
        domainNotAllowed: 18,
        invalidPrimaryCourse: 1,
        invalidEmailFormat: 2,
    },
    newTeams: {
        nir2: 2,
        nirx: 1,
        nir111: 1,
        nxir: 1,
        niry: 5,
        nixr: 1,
    },
    draftUserIds: [
        36563, 36564, 36565, 36566, 36567, 36568, 36569, 36570, 36571, 36572, 36573, 36574, 36575, 36576, 36577, 36578,
        36579, 36580,
    ],
    nonManagedTeams: {},
    erroneousPrimaryCourses: {
        courseError: 1,
    },
};
exports.licenseMock = {
    numberOfPendingInvitations: 36,
    numberOfInvitationsDraftUsers: 5,
    numberOfAvailableSeats: 100,
    susbscriptionEndDate: '2024-01-23T15:22:57.000Z',
};
exports.invitationSummaryMock = {
    totalUsers: 500000000,
    admins: [
        'admin1',
        'admin2',
        'admin3',
        'admin4',
        'admin5',
        'admin6',
        'admin7',
        'admin8',
        'admin9',
        'admin10',
        'admin11',
        'admin12',
    ],
    newTeams: [
        'Bomba team',
        'Pomba team',
        'Momba team',
        'Jomba team',
        'Tomba team',
        'Zomba team',
        'Lomba team',
        'Romba team',
        'Komba team',
    ],
    mainLearning: [
        'Python',
        'Java',
        '.Net',
        'C++',
        'C#',
        'JavaScript',
        'TypeScript',
        'React',
        'Angular',
        'Vue',
        'Node',
        'Express',
        'MongoDB',
        'SQL',
        'PostgreSQL',
        'MySQL',
        'Docker',
        'Kubernetes',
        'AWS',
        'Azure',
        'GCP',
    ],
};
exports.mockInvitationEmailLogoUrl = {
    uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
    signedUrl: 'www.s3.com/images/file-name.svg',
    contentType: 'svg',
    contentUrl: 'www.images.codebashing.com/file-name.svg',
};
